module.exports = __webpack_public_path__ + "static/media/msg-erro.e393c3c2.svg";